import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "-2 -2 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-2 -2 20 20\" id=\"logout\"><path d=\"M6.302 11.191l1.253 1.253L12 8 7.556 3.556 6.302 4.809l2.293 2.302H0v1.778h8.596l-2.294 2.302zM14.222 0H1.778C.791 0 0 .8 0 1.778v3.556h1.778V1.778h12.444v12.444H1.778v-3.556H0v3.556C0 15.2.791 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/logout.svg
// module id = qX2G
// module chunks = 39 44